/**
 * CleverTap Discount Validator — zarr.com.pk
 *
 * Add this file to your Shopify theme:
 *   Shopify Admin → Online Store → Themes → Edit code
 *   → assets/ct-discount-validator.js  (paste this file)
 *
 * Then include it in your cart template (cart.liquid or sections/main-cart-footer.liquid):
 *   <script src="{{ 'ct-discount-validator.js' | asset_url }}" defer></script>
 *
 * UPDATE CT_MIDDLEWARE_URL below whenever the server URL changes.
 */

(function () {
  'use strict';

  // ── CONFIG ──────────────────────────────────────────────────────────────────
  // Update this when ngrok URL changes, or replace with your deployed server URL
  var CT_MIDDLEWARE_URL = 'https://flawiest-uncriticisable-loraine.ngrok-free.dev';

  // ── Styles ───────────────────────────────────────────────────────────────────
  var CSS = [
    '#ct-discount-wrap { margin: 16px 0; }',
    '#ct-discount-wrap .ct-label { font-size: 13px; font-weight: 600; margin-bottom: 8px; display: block; }',
    '#ct-discount-row { display: flex; gap: 8px; }',
    '#ct-coupon-input { flex: 1; padding: 10px 12px; border: 1px solid #ccc; border-radius: 4px; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; }',
    '#ct-coupon-input:focus { outline: none; border-color: #000; }',
    '#ct-coupon-btn { padding: 10px 18px; background: #222; color: #fff; border: none; border-radius: 4px; cursor: pointer; font-size: 14px; white-space: nowrap; }',
    '#ct-coupon-btn:disabled { opacity: 0.6; cursor: not-allowed; }',
    '#ct-coupon-msg { margin-top: 8px; font-size: 13px; display: none; padding: 8px 12px; border-radius: 4px; }',
    '#ct-coupon-msg.ct-error { background: #fff0f0; color: #c0392b; border: 1px solid #f5c6c6; }',
    '#ct-coupon-msg.ct-success { background: #f0fff4; color: #27ae60; border: 1px solid #c6e9d0; }',
  ].join('\n');

  function injectStyles() {
    var el = document.createElement('style');
    el.textContent = CSS;
    document.head.appendChild(el);
  }

  // ── Build the discount form UI ───────────────────────────────────────────────
  function buildForm() {
    var wrap = document.createElement('div');
    wrap.id = 'ct-discount-wrap';
    wrap.innerHTML =
      '<span class="ct-label">Have a discount code?</span>' +
      '<div id="ct-discount-row">' +
        '<input id="ct-coupon-input" type="text" placeholder="Enter coupon code" autocomplete="off">' +
        '<button id="ct-coupon-btn" type="button">Apply</button>' +
      '</div>' +
      '<div id="ct-coupon-msg"></div>';
    return wrap;
  }

  // ── Show a result message ────────────────────────────────────────────────────
  function showMsg(text, type) {
    var el = document.getElementById('ct-coupon-msg');
    if (!el) return;
    el.className = 'ct-' + type;
    el.textContent = text;
    el.style.display = 'block';
  }

  function hideMsg() {
    var el = document.getElementById('ct-coupon-msg');
    if (el) el.style.display = 'none';
  }

  // ── Fetch cart and build items payload for CT ────────────────────────────────
  function getCartItems() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var order = {
          saleAmount: cart.total_price / 100,
          orderStatus: 'pending',
        };

        // Shopify `vendor` field === CleverTap `brand` condition
        var items = (cart.items || []).map(function (item) {
          return {
            productId: String(item.product_id),
            sku: item.sku || '',
            itemName: item.title || '',
            category: item.product_type || '',
            brand: item.vendor || '',   // ← key mapping: Shopify vendor → CT brand
            unitPrice: item.price / 100,
            quantity: item.quantity,
            grossAmount: (item.price * item.quantity) / 100,
          };
        });

        return { order: order, items: items };
      });
  }

  // ── Call the middleware validate endpoint ────────────────────────────────────
  function callValidate(couponCode, order, items) {
    var body = JSON.stringify({
      couponCode: couponCode,
      order: order,
      items: items,
    });

    return fetch(CT_MIDDLEWARE_URL + '/api/validate-coupon', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': '1',   // skip ngrok browser warning page
      },
      body: body,
    }).then(function (r) { return r.json(); });
  }

  // ── Main handler when Apply is clicked ──────────────────────────────────────
  function handleApply() {
    var input = document.getElementById('ct-coupon-input');
    var btn = document.getElementById('ct-coupon-btn');
    if (!input || !btn) return;

    var code = input.value.trim().toUpperCase();
    if (!code) { showMsg('Please enter a coupon code.', 'error'); return; }

    btn.disabled = true;
    btn.textContent = 'Checking...';
    hideMsg();

    getCartItems()
      .then(function (payload) {
        return callValidate(code, payload.order, payload.items);
      })
      .then(function (result) {
        if (result.valid) {
          var discount = result.savings && result.savings.orderDiscount
            ? ' You save Rs. ' + Math.round(result.savings.orderDiscount)
            : '';
          showMsg('✓ Coupon valid!' + discount + ' Applying...', 'success');

          // Apply discount via Shopify's built-in redirect and go to checkout
          setTimeout(function () {
            window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
          }, 800);
        } else {
          var errMsg = (result.error && result.error.message) || 'Coupon is not valid for your cart.';
          showMsg(errMsg, 'error');
          btn.disabled = false;
          btn.textContent = 'Apply';
        }
      })
      .catch(function () {
        showMsg('Could not verify coupon. Please try again.', 'error');
        btn.disabled = false;
        btn.textContent = 'Apply';
      });
  }

  // ── Find the best insertion point in the cart ────────────────────────────────
  function findInsertTarget() {
    // Try common selectors used by Volume and other themes
    var selectors = [
      '.cart__ctas',
      '.cart-footer__checkout',
      '[name="checkout"]',
      '.cart__checkout-button',
      '#CartDrawer-Checkout',
      '.cart-drawer__footer',
      'button[name="checkout"]',
      'form[action="/cart"] [type="submit"]',
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  // ── Initialise ───────────────────────────────────────────────────────────────
  function init() {
    // Don't run on pages other than /cart
    if (window.location.pathname !== '/cart') return;

    var target = findInsertTarget();
    if (!target) {
      // Re-try once after a short delay in case theme renders lazily
      setTimeout(function () {
        target = findInsertTarget();
        if (target) mountForm(target);
      }, 600);
      return;
    }
    mountForm(target);
  }

  function mountForm(target) {
    if (document.getElementById('ct-discount-wrap')) return; // already mounted

    injectStyles();
    var form = buildForm();

    // Insert before the checkout button (or its container)
    var parent = target.parentElement || document.body;
    parent.insertBefore(form, target);

    document.getElementById('ct-coupon-btn').addEventListener('click', handleApply);
    document.getElementById('ct-coupon-input').addEventListener('keydown', function (e) {
      if (e.key === 'Enter') handleApply();
    });
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
